import { Address, Shipment, TimeWindow } from "@/model/transportorder/transportOrder"

export interface TransportChainPartyDetails {
    name?: string
    duns?: string
    address?: Address
    timeWindow?: TimeWindow
}

export const getAdminConsignorDetails = (transportOrder: Shipment): TransportChainPartyDetails => ({
    name: transportOrder.startOfTransportChain.consignor.name,
    duns: transportOrder.startOfTransportChain.consignor.externalIdentifiers.duns,
    address: transportOrder.startOfTransportChain.consignor.address,
    timeWindow: transportOrder.startOfTransportChain.pickupRequestedAt,
})

export const getAdminConsigneeDetails = (transportOrder: Shipment): TransportChainPartyDetails => ({
    name: transportOrder.endOfTransportChain.consignee.name,
    duns: transportOrder.endOfTransportChain.consignee.externalIdentifiers.duns,
    address: transportOrder.endOfTransportChain.consignee.address,
    timeWindow: transportOrder.endOfTransportChain.deliveryEstimatedAt,
})
